export default "__VITE_ASSET__C2$sDCoy__"